import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from './auth'

// const baseUrl = '/api'
const baseUrl = 'http://www.yamip.com.cn/api'

let loading = null

const BASE_URL = baseUrl;

// create an axios instance
const service = axios.create({
    baseURL: BASE_URL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // console.log(config.data, 'config');
        // do something before request is sent
        loading = Loading.service({
            lock: true,
            text: '加载中 . . .',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })

        // 用来判断是否是登录接口

        let Author = '';
        if (config.data && config.data.get) {
            Author = config.data.get('Authorization');
        }


        if (store.getters.token && !Author) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Authorization'] = `Bearer ${getToken()}`
        }
        config.headers['client_id'] = `test-client`
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        loading.close();
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 0 && res.code !== 200) {
            if (res.code === 900007) {
                return
            }
            if (res.code === 900001) {
                // to re-login
                store.dispatch('user/resetToken').then(() => {
                    location.reload()
                })
            }
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 2 * 1000
            })
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        loading.close();
        console.log('err' + error) // for debug
        Message({
            message: '请求失败',
            type: 'error',
            duration: 2 * 1000
        })
        return Promise.reject(error)

    }
)

export default service



// WEBPACK FOOTER //
// ./src/api/index.js